import { field, date, relation, writer,text } from '@nozbe/watermelondb/decorators';
import { SALE_ORDER_LINE_SCHEMA } from '../schema';
import { Model } from '@nozbe/watermelondb';

export default class SaleOrderLine extends Model {
    static table = SALE_ORDER_LINE_SCHEMA;

    static associations = {
        sale_order: { type: 'belongs_to', key: 'sale_order_id' },
        stock: { type: 'belongs_to', key: 'stock_id' },
    }

    @field('is_secondary_unit') is_secondary_unit;
    @field('unit_conversion') unit_conversion;
    @text('discount_method') discount_method;
    @text('secondary_unit') secondary_unit;
    @field('selling_price') selling_price;
    @date('transacted_at') transacted_at;
    @field('is_open_item') is_open_item;
    @field('cost_price') cost_price;
    @field('inclusive') inclusive;
    @text('tran_type') tran_type;
    @field('discount') discount;
    @field('quantity') quantity;
    @text('name') name;
    @text('type') type;
    @text('unit') unit;
    @field('tax') tax;

    @relation('sale_order', 'sale_order_id') sale_order;
    @relation('stock', 'stock_id') stock;

    @writer async updateName(name) {
        await this.update((saleOrder) => {
            saleOrder.name = name;
        });
    }
    @writer async updateQuantity(quantity) {
        await this.update((saleOrder) => {
            saleOrder.quantity = quantity;
        });
    }
    @writer async updateSellingPrice(selling_price) {
        await this.update((saleOrder) => {
            saleOrder.selling_price = selling_price;
        });
    }
    @writer async updateDiscount(discount) {
        await this.update((saleOrder) => {
            saleOrder.discount = discount;
        });
    }
    @writer async updateDiscountMethod(discount_method) {
        await this.update((saleOrder) => {
            saleOrder.discount_method = discount_method;
        });
    }
}